<div class="survey-positive-container">
  <div class="survey-positive-container__header">
    <span class="survey-positive-container__header__title">
      Please provide more details
    </span>
    <i (click)="onCloseSurvey()" class="icon-close icon-16"></i>
  </div>

  <span class="survey-positive-container__title"></span>

  <form [formGroup]="form">
    <gcc-character-counter [withLimit]="300" gccValidation>
      <gcc-textarea-input [label]="questionTitle" formControlName="text" [maxLength]="300"></gcc-textarea-input>
    </gcc-character-counter>
  </form>

  <div class="survey-positive-container__actions">
    <button [disabled]="!form.valid" class="btn btn-primary" (click)="onSubmit()">Submit</button>
  </div>
</div>
